import { Component, Input } from '@angular/core';


export class SkyLabelComponent {
  
  public labelType: string;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-label',
  template: `<span class="sky-label" [ngClass]="labelType ? 'sky-label-' + labelType : 'sky-label-info'">
  <ng-content></ng-content>
</span>
`,
  styles: [`.sky-label {
  color: #282b31;
  display: inline;
  border-radius: 10rem;
  font-weight: 400;
  line-height: 2.2;
  margin: 0 3px;
  padding: .3em .6em .3em .6em;
  white-space: nowrap;
}

.sky-label-success {
  background-color: #b7da9b;
}

.sky-label-success:before {
  content: "\\f00c";
  font-family: FontAwesome;
}

.sky-label-info {
  background-color: #81d4f7;
}

.sky-label-info:before {
  content: "\\f06a";
  font-family: FontAwesome;
}

.sky-label-warning {
  background-color: #ffd597;
}

.sky-label-warning:before {
  content: "\\f071";
  font-family: FontAwesome;
}

.sky-label-danger {
  background-color: #f7a08f;
}

.sky-label-danger:before {
  content: "\\f071";
  font-family: FontAwesome;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'labelType': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
